import * as React from 'react';
import ModalContainer from '@src/components/modal-container';
// import Button from '@src/components/button';
import CloseBtn from '@src/business-components/close-btn';
import keyFrames from '@src/global/style/keyframes.less';
import './index.less';

/**
 * 弹窗模板, 可以快速套用修改
 */
const Layout = ({ isOpen, onClose, children, className, ...rest }) => {
  return (
    <ModalContainer modalState={isOpen} className={className} {...rest}>
      <div className="modal-container">
        <CloseBtn className="modal-close" onClick={onClose} />
        <div style={{ '--fadeIn': keyFrames.fadeIn }} className="modal-content">
          {children}
        </div>
      </div>
    </ModalContainer>
  );
};

export default Layout;
